import React from 'react';
import clsx from 'clsx';

/**
 * This component is responsible for rendering the left table with labels 
 * next to the body of markdown at about page.
 */
const SideBarMarkdown = (props) => {
    
    const {
        refArray,
        elSubRefs,
        scrollTop 
    } = props;

    //  This function checks if our viewpoint is at the first position ref.
    const checkFirstPositionBasicRefs = (refIndex) => {
        if(refArray[refIndex] !== undefined && refArray[refIndex].current !== null){
            //  If our viewpoint (scrollTop) is lower than offsetTop of second ref then we are the first area viewpoint
            if(scrollTop < refArray[refIndex+1].current.offsetTop){
                return true;   
            }
        }
        return false;
    }

    //  This function checks if our viewpoint is at the last position ref.
    const checkLastPositionBasicRefs = (refIndex) => {
        if(refArray[refIndex] !== undefined && refArray[refIndex].current !== null){
            //  If our viewpoint is higher than the offsetTop of last ref then we are at the last area viewpoint
            if(scrollTop > refArray[refIndex ].current.offsetTop){
                return true;
            }
        }
        return false;
        
    }

    //  This function given a refIndex returns if our viewpoint is the specific area that correspond to this refIndex.
    const checkMiddlePositionBasicRefs = (refIndex) => {
        //  If our viewpoint is between the height of the next examined ref and our examined ref then our viewpoint is at the area that we examine
        if(refArray[refIndex].current.offsetTop < scrollTop && scrollTop < refArray[refIndex + 1].current.offsetTop){
            return true;
        }
        return false;
        
    }

    return(
        <nav style={{position: 'absolute', width: '23%',height: '75%'}} className ={clsx('hidden-xs', 'hidden-sm', 'bs-docs-sidebar')} 
        >
            <ul style={{display: 'flex', flexDirection: 'column',flexWrap: 'nowrap', overflowY: 'auto', maxHeight: '75vh'}} id="sidebar" className={clsx('nav', 'nav-stacked')}>
                <li>
                <p style={{fontWeight: '600'}}>About WABLI</p>
                </li>
                <li style={{marginTop: '0.2rem'}} id='WhatIsWABLI'>
                    <a  id='MainLabelElement0' className={checkFirstPositionBasicRefs(0) === true  ? clsx('activeContent') : clsx('labelContent1')} href="#Group1">What is WABLI?</a>
                </li>
                <li style={{marginTop: '0.2rem'}}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <p style={{fontWeight: '600'}}>Example scenario 1 </p> 
                        <p> &nbsp;- Building a product </p> 
                        <p>&nbsp;listing web application</p>
                    </div>

                    
                </li>           
                <li style={{marginTop: '0.2rem'}} id='LandingPage'>
                    <a id='MainLabelElement4' className={ (refArray[1] !== undefined && refArray[1].current !== null && checkMiddlePositionBasicRefs(1) === true ) ? clsx('activeContent') : clsx('labelContent1')} href="#Group5">Landing page / Login</a>
                </li>
                <li style={{marginTop: '0.2rem'}} id='CreateNewProject'>
                    <a id='MainLabelElement5' className={ (refArray[2] !== undefined && refArray[2].current !== null && checkMiddlePositionBasicRefs(2) === true ) ? clsx('activeContent') : clsx('labelContent1')} href="#Group6">Create new project</a>
                </li>
                <li style={{marginTop: '0.2rem'}} id ='CreatePage'>
                    <a id='MainLabelElement6' className={ (refArray[3] !== undefined && refArray[3].current !== null && checkMiddlePositionBasicRefs(3) === true ) ? clsx('activeContent') : clsx('labelContent1')} href="#Group7">Create new page</a>
                </li>
                <li style={{marginTop: '0.2rem'}} id='DesignPage'>
                    <a id='MainLabelElement7' className={ (refArray[4] !== undefined && refArray[4].current !== null && checkMiddlePositionBasicRefs(4) === true)  ? clsx('activeContent') : clsx('labelContent1')} href="#Group8">Design your page</a>
                    <SubSideBarOptions 
                        checkMiddlePositionBasicRefs={checkMiddlePositionBasicRefs}
                        refArray={refArray}
                        elSubRefs={elSubRefs}
                        scrollTop={scrollTop}
                    />
                </li>
                <li style={{marginTop: '0.2rem'}} id ='PageFlow'>
                    <a id='MainLabelElement8' className={ (refArray[5] !== undefined && refArray[5].current !== null && checkMiddlePositionBasicRefs(5) === true )  ? clsx('activeContent') : clsx('labelContent1')} href="#Group9">Page Flow</a>
                </li>
                <li style={{marginTop: '0.2rem'}} id ='PageFlow'>
                    <a id='MainLabelElement9' className={ (refArray[6] !== undefined && refArray[6].current !== null && checkMiddlePositionBasicRefs(6) === true )  ? clsx('activeContent') : clsx('labelContent1')} href="#Group10">Creating new Forms</a>
                </li>
                <li style={{marginTop: '0.2rem'}} id ='PageFlow'>
                    <a id='MainLabelElement10' className={checkLastPositionBasicRefs(7) === true  ? clsx('activeContent') : clsx('labelContent1')} href="#Group11">Data Model</a>
                </li>
            </ul>
        </nav>
    )
}

//  This component returns the sub labels of the table next to markdown.
const SubSideBarOptions = ({checkMiddlePositionBasicRefs,refArray, elSubRefs, scrollTop}) => {

    //  This functions checks if our viewpoint is not  at the last sub ref ( at first or at middel subrefs)
    const checkMiddlePositionSubBasicRef = (subRefIndex) => {
        if( elSubRefs[subRefIndex].current.offsetTop < scrollTop && scrollTop < elSubRefs[subRefIndex + 1].current.offsetTop ){
            return true;
        }
         return false;
        
    } 

    //  This function checks if our viewpoint is at the last sub ref
    const checkLastPositionSubBasicRef = (subRefIndex) => {
        if(elSubRefs[subRefIndex] !== undefined && elSubRefs[subRefIndex].current !== null){
            if( scrollTop > elSubRefs[subRefIndex ].current.offsetTop){
                return true;
            }
        }
        return false;
        
    }

    return(
            (refArray[4] !== undefined && refArray[4].current !== null && checkMiddlePositionBasicRefs(4) === true ) &&
                <ul className={clsx('nav', 'nav-stacked')} style={{display: 'flex', flexDirection: 'column'}}>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement1' className={ (elSubRefs[0] !== undefined && elSubRefs[0].current !== null && checkMiddlePositionSubBasicRef(0) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub1">Insert/Edit a Navbar</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement2' className={ (elSubRefs[1] !== undefined && elSubRefs[1].current !== null && checkMiddlePositionSubBasicRef(1) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub2">Insert/Edit a Breadcrumb</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement3' className={ (elSubRefs[2] !== undefined && elSubRefs[2].current !== null && checkMiddlePositionSubBasicRef(2) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub3">Insert Column</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement4' className={ (elSubRefs[3] !== undefined && elSubRefs[3].current !== null && checkMiddlePositionSubBasicRef(3) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub4">Insert a List Group</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement5' className={ (elSubRefs[4] !== undefined && elSubRefs[4].current !== null && checkMiddlePositionSubBasicRef(4) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub5">Edit a List Group</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement6' className={ (elSubRefs[5] !== undefined && elSubRefs[5].current !== null && checkMiddlePositionSubBasicRef(5) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub5">Insert a List Item</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement7' className={ (elSubRefs[6] !== undefined && elSubRefs[6].current !== null && checkMiddlePositionSubBasicRef(6) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub6">Duplicate a List Item</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement8' className={ (elSubRefs[7] !== undefined && elSubRefs[7].current !== null && checkMiddlePositionSubBasicRef(7) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub7">Adding an image</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement9' className={ (elSubRefs[8] !== undefined && elSubRefs[8].current !== null && checkMiddlePositionSubBasicRef(8) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub9">Editing a List Items</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement10' className={ (elSubRefs[9] !== undefined && elSubRefs[9].current !== null && checkMiddlePositionSubBasicRef(9) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub10">Create a new page</a></li>
                    <li  style={{marginTop: '0.2rem'}} ><a id='SubLabelElement11' className={ (elSubRefs[10] !== undefined && elSubRefs[10].current !== null && checkLastPositionSubBasicRef(10) === true )  ? clsx('activeContent2') : clsx('labelContent2')} href="#Group8Sub11">Adding blocks to your new page</a></li>
                </ul>
    )
}

export default SideBarMarkdown;